import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import InvoicingSummary from '../models/InvoicingSummary';
import InvoicingTask from '../models/InvoicingTask';
import Subtotals from '../models/Subtotals';
import { ABSTRACT_SCHEMA } from './taskConverters';

const SUMMARY_SCHEMA = {
  subtotals: (data: any) => parseSubtotals(data.subTotals),
  tasks: (data: any) => parseInvoicingTasks(data.dossiers),
};

const SUBTOTALS_SCHEMA = {
  countToday: 'countToday',
  countThisWeek: 'countThisWeek',
  countOlder: 'countOlder',
  amountToday: 'amountToday',
  amountThisWeek: 'amountThisWeek',
  amountOlder: 'amountOlder',
};

const TASK_SCHEMA = {
  ...ABSTRACT_SCHEMA,
  assignedUserId: 'assignedTo',
  amount: 'amount',
  period: 'periodFilter',
  tags: (data: any) => parseTags(data.tags),
};

function parseSubtotals(data: any): Subtotals {
  return parseEntity(data, SUBTOTALS_SCHEMA, Subtotals) ?? new Subtotals();
}

function parseInvoicingTasks(data: any): Array<InvoicingTask> {
  return parseEntities(data, parseInvoicingTask);
}

function parseInvoicingTask(data: any): InvoicingTask | null {
  data.dossierId = data.id;
  return parseEntity(data, TASK_SCHEMA, InvoicingTask);
}

export function parseInvoicingSummary(data: any): InvoicingSummary | null {
  return parseEntity(data, SUMMARY_SCHEMA, InvoicingSummary);
}